/* WoodHarmonyUS — home v24. Tickers, arrows, no dependencies. */
(function () {
  'use strict';
  /* Every wh-home-* section links this file, so the browser executes it once
     per tag. Without this guard the tickers would clone their cards again on
     each run. */
  if (window.__whHomeBooted) return;
  window.__whHomeBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 760px)');
  function mobileHome(){ return mobile.matches && !!document.querySelector('.wh-home-hero'); }

  function arrows(track, sel) {
    document.querySelectorAll(sel).forEach(function (b) {
      b.addEventListener('click', function () {
        var c = track.firstElementChild;
        var step = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : 340;
        track.scrollBy({ left: (b.dataset.dir === 'next' ? 1 : -1) * step, behavior: 'smooth' });
      });
    });
  }

  function ticker(track, speed, arrowSel) {
    if (!track || track.dataset.whReady) return;
    track.dataset.whReady = '1';
    if (arrowSel) arrows(track, arrowSel);
    if (reduce) return;
    if (track.scrollWidth <= track.clientWidth + 4) return;

    var half = 0, paused = false, last = 0, pos = 0;
    [].slice.call(track.children).forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      if (c.tagName === 'A') c.setAttribute('tabindex', '-1');
      c.querySelectorAll('a,button').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      track.appendChild(c);
    });
    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);

    function tick(ts) {
      if (!last) last = ts;
      var dt = ts - last; last = ts;
      if (!paused && !mobileHome()) {
        pos += dt * speed;
        if (half && pos >= half) pos -= half;
        track.scrollLeft = pos;             /* accumulate in JS: scrollLeft rounds to whole px */
      }
      requestAnimationFrame(tick);
    }
    function pause() { paused = true; }
    function play() { pos = track.scrollLeft; last = 0; paused = false; }
    ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (e) {
      track.addEventListener(e, pause, { passive: true });
    });
    ['pointerleave', 'focusout', 'touchend'].forEach(function (e) {
      track.addEventListener(e, play, { passive: true });
    });
    if (arrowSel) document.querySelectorAll(arrowSel).forEach(function (b) {
      b.addEventListener('pointerenter', pause);
      b.addEventListener('pointerleave', play);
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? pause() : play(); });
    track.style.scrollBehavior = 'auto';
    track.style.scrollSnapType = 'none';    /* mandatory snapping fights a continuous ticker */
    requestAnimationFrame(tick);
  }

  function boot() {
    var aboutLink=document.querySelector('.whm-menu a');
    if(aboutLink) aboutLink.addEventListener('click',function(){
      var drawer=aboutLink.closest('header-drawer');
      var toggle=drawer && drawer.querySelector('summary');
      if(toggle) toggle.click();
    });
    document.querySelectorAll('[data-wh-ticker]').forEach(function (t) {
      var speed = parseFloat(t.dataset.whSpeed || '0.03');
      var sel = t.dataset.whArrows ? '[data-wh-for="' + t.dataset.whArrows + '"]' : null;
      ticker(t, speed, sel);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

